import type {HTMLChakraProps} from '@chakra-ui/react';
import {ChakraHeader} from '@linx-security/ui/utils/chakra-elements';
import type {PropsWithChildren} from 'react';

import {useStyles} from './context';
import {parts} from './theme/anatomy';

type Props = PropsWithChildren<HTMLChakraProps<`header`>>;

export const NavHeader = (props: Props) => {
  const {header: style} = useStyles();
  return <ChakraHeader __css={style} {...parts.header.attrs} {...props} />;
};
